import Vue from 'vue'
const url = window.$website.url
const request = Vue.prototype.$axios;
const baseUrl = url + '/allocation'

export const operationData = (data) => request({
  url: baseUrl + '/update',
  method: 'post',
  data: data
});
